export const fetchMeliplusInfoHelper = async ({ dispatch, getState, apiService, actionTypes }) => {
  dispatch({ type: actionTypes.START });

  try {
    const state = getState();
    const loyaltyCard = state?.components?.loyalty_collapsible_card;
    const loyaltyProps = loyaltyCard?.benefits_props;
    const fallback = loyaltyCard?.fallback;

    const params = {
      shipping_original_amount: loyaltyProps?.shipping_original_amount,
      shipping_amount: loyaltyProps?.shipping_amount,
      cashback_amount: loyaltyProps?.cashback_amount,
      financing_group: loyaltyProps?.financing_group,
    };

    const data = await apiService.getMeliplusInfo(params);
    const isEmptyObject = data && Object.keys(data).length === 0;

    if (isEmptyObject) {
      dispatch({ type: actionTypes.ERROR, payload: fallback });
    } else {
      dispatch({ type: actionTypes.COMPLETE, payload: data });
    }
  } catch (error) {
    const fallback = getState()?.components?.loyalty_collapsible_card?.fallback;
    dispatch({ type: actionTypes.ERROR, payload: fallback });
  }
};
